import React from 'react';
import styles from './Layout.module.css';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div className={styles.container}>
      <div className={styles.leftCol}>
        {/* Futuro menu lateral pode ser inserido aqui */}
      </div>
      <section className={styles.section}>
        {children}
      </section>
    </div>
  );
};

export default Layout;